import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./style.module.css";
;
const Optgroup = ({ children, label }) => {
    return (_jsx("li", { children: _jsxs("ul", { className: styles['optgpoup'], children: [label && _jsx("li", { className: styles['label'], children: label }), children] }) }));
};
export default Optgroup;
